import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../../../Context/AuthContext";
import { buildProductUpdatePayload } from "../../../../dashboard/merchant/utils/productForm";

const parseErrorMessage = async (response) => {
  try {
    const data = await response.json();
    return data.message || "Failed to update product.";
  } catch (_) {
    return "Failed to update product.";
  }
};

const useEditProduct = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext);

  const editProduct = useMutation(
    async ({ id, form, price, compareAtPrice, newImages = [], removedImages = [] }) => {
      const payload = buildProductUpdatePayload(form, price, compareAtPrice);
      const body = new FormData();

      Object.entries(payload).forEach(([key, value]) => {
        if (key === "attributes") {
          body.append("attributes", JSON.stringify(value || {}));
        } else {
          body.append(key, value);
        }
      });

      if (removedImages.length) {
        body.append("removedImages", JSON.stringify(removedImages));
      }

      newImages.forEach((file) => body.append("images", file));

      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/product/update/product/${id}`,
        {
          method: "PATCH",
          headers: { Authorization: `Bearer ${token}` },
          body,
        }
      );

      if (!response.ok) {
        throw new Error(await parseErrorMessage(response));
      }

      return response.json();
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries("merchantProducts");
        queryClient.invalidateQueries("productDetails");
        if (data?.product?._id) {
          queryClient.setQueryData(["productDetails", data.product.slug], data);
          queryClient.setQueryData(["productDetails", data.product._id], data);
        }
      },
    }
  );

  return {
    editProduct,
    isLoading: editProduct.isLoading,
  };
};

export default useEditProduct;
